'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventContact = function EventContact(_ref) {
  var name = _ref.name,
      phone = _ref.phone,
      email = _ref.email,
      url = _ref.url;

  var contactInfo = [];

  if (name) contactInfo.push({ key: 'name', element: name });
  if (phone) contactInfo.push({ key: 'phone', element: _react2.default.createElement(
      'a',
      { href: 'tel:+1-' + phone },
      phone
    ) });
  if (email) contactInfo.push({ key: 'email', element: _react2.default.createElement(
      'a',
      { href: 'mailto:' + email },
      email
    ) });
  if (url) contactInfo.push({ key: 'url', element: _react2.default.createElement(
      'a',
      { href: url, target: '_blank', rel: 'noopener noreferrer' },
      url
    ) });

  if (contactInfo.length === 0) {
    return null;
  }

  return _react2.default.createElement(
    'div',
    { className: 'EventContact' },
    _react2.default.createElement(
      'ul',
      null,
      contactInfo.map(function (info) {
        return _react2.default.createElement(
          'li',
          { key: info.key },
          info.element
        );
      })
    )
  );
};

EventContact.propTypes = {
  /** The contact's name. */
  name: _propTypes2.default.string,
  /** The contact's phone number. */
  phone: _propTypes2.default.string,
  /** The contact's email address. */
  email: _propTypes2.default.string,
  /** The contact's website. */
  url: _propTypes2.default.string
};

EventContact.defaultProps = {
  name: null,
  phone: null,
  email: null,
  url: null
};

exports.default = EventContact;
EventContact.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'EventContact',
  'props': {
    'name': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The contact\'s name.'
    },
    'phone': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The contact\'s phone number.'
    },
    'email': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The contact\'s email address.'
    },
    'url': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'The contact\'s website.'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventContact.js
// module id = 179
// module chunks = 0